import React from 'react'
import { cn } from 'utils'

const SectionLayout = ({
  children,
  className,
  ...props
}: {
  children: React.ReactNode
  className?: string
} & React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      {...props}
      className={cn('flex flex-col gap-16 py-20 px-4 text-gray-50', className)}>
      {children}
    </div>
  )
}

export default SectionLayout
